import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackSelfContent, StackType, StackWidth, TypographyTypeDLS, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { failedVerification, onLoad, successVerification } from "./actions";
import { ACTION } from "./types";
export const template = () => ({
    layout: {
        id: ROUTE.KYC_DIGIO_RESPONSE,
        type: LAYOUTS.LIST,
        widgets: [
            { id: 'body', type: WIDGET.STACK, position: POSITION.ABSOLUTE_CENTER }
        ],
    },
    datastore: {
        body: {
            alignItems: StackAlignItems.center,
            alignSelf: StackSelfContent.center,
            type: StackType.column,
            widgetItems: [
                { id: "lottieStack", type: WIDGET.STACK },
                { id: "space80", type: WIDGET.SPACE },
                { id: 't1', type: WIDGET.TEXT }
            ]
        },
        lottieStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            alignSelf: StackSelfContent.center,
            alignContent: StackAlignContent.center,
            widgetItems: [
                { id: "lottie", type: WIDGET.LOTTIE }
            ]
        },
        lottie: {
            uri: LottieTokens.SandTimer,
            size: LottieSizeTokens.XXL,
            autoplay: true,
            loop: true,
        },
        t1: {
            label: 'Loading, please wait...',
            typeDLS: TypographyTypeDLS.B0S
        },
        space80: {
            size: SizeTypeTokens.NONE
        },
    },
});
export const kycDigioResponse = {
    onLoad: async (_) => {
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.ON_LOAD]: onLoad,
    },
    action: {
        routeId: ROUTE.KYC_DIGIO_RESPONSE,
        type: ACTION.ON_LOAD,
        payload: {}
    },
};
